import { api } from "@repo/convex/api";
import { useQuery } from "convex/react";

/**
 * Hook to get the current authenticated user's Convex record.
 * Returns the full user document (including `_id`) or `undefined` while loading.
 *
 * Use this when you need the Convex user ID (e.g., to pass `authorId` to mutations).
 * For WorkOS-level auth state (sign in/out), use `useAuth()` from WorkOS instead.
 */
export function useCurrentUser() {
  return useQuery(api.users.me, {});
}
